import React, { useState } from 'react';
import { Button, Container, Box, Typography, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import constants from '../utils/constants';
import { useLang } from "../context/LangContext";
import locales from '../locales.json';

const { BACKEND_URL } = constants;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();
  const { lang } = useLang();
  const { forgot_password_page } = locales;

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError('');
    setSuccessMessage('');

    if (!email) {
      setError(forgot_password_page.enter_email_error[lang]);
      return;
    }

    try {
      const response = await axios.post(`${BACKEND_URL}/authentication/forgot-password`, { email, lang });

      if (response.data.message) {
        navigate('/reset-password-email-sent');
      }
    } catch (error) {
      setError(forgot_password_page.send_email_error[lang]);
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '0', // Enlève la contrainte de hauteur
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start', // Commence en haut
        py: { xs: 4, md: 6 }, // Padding vertical raisonnable
        px: { xs: 1, sm: 2, md: 0 },
        boxSizing: 'border-box',
        width: '100%',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#f9f9f9',
          padding: { xs: '20px', sm: '32px' },
          borderRadius: '16px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          width: '100%',
          maxWidth: '400px',
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h4" gutterBottom align="center" sx={{ fontSize: { xs: '1.7rem', md: '2rem' } }}>
          {forgot_password_page.title[lang]}
        </Typography>
        
        {error && (
          <Typography color="error" sx={{ marginTop: '8px', textAlign: 'center', fontSize: { xs: '0.95rem', md: '1rem' } }}>
            {error}
          </Typography>
        )}
        
        {successMessage && (
          <Typography color="primary" sx={{ marginTop: '8px', textAlign: 'center', fontSize: { xs: '0.95rem', md: '1rem' } }}>
            {successMessage}
          </Typography>
        )}
        
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <TextField
            fullWidth
            label={forgot_password_page.email_label[lang]}
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
            variant="outlined"
          />
          
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{
              marginTop: '24px',
              padding: { xs: '10px 0', md: '12px 0' },
              borderRadius: '24px',
              fontSize: { xs: '1rem', md: '1.1rem' },
            }}
          >
            {forgot_password_page.send_button[lang]}
          </Button>
        </form>

        <Button
          variant="outlined"
          color="primary"
          fullWidth
          sx={{
            marginTop: '16px',
            padding: { xs: '10px 0', md: '12px 0' },
            borderRadius: '24px',
            fontSize: { xs: '1rem', md: '1.1rem' },
          }}
          onClick={() => navigate('/signin')}
        >
          {forgot_password_page.back_to_signin[lang]}
        </Button>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
